export default __webpack_public_path__ + "static/media/giphy.94ea4d88.gif";